import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, CircularProgress }  from '@material-ui/core';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
// import DialogContentText from '@material-ui/core/DialogContentText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Switch from '@material-ui/core/Switch';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
// import styles from './customer.module.scss'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const filter = createFilterOptions();
const OPTIONS_LIMIT = 10

const filterOptions = (options, state) => {
  return filter(options, state).slice(0, OPTIONS_LIMIT);
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '80%',
    margin: '20px'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  gridParent: {
    margin: '10px',
    padding: '10px',
    width: '95%',
    border: '3px solid #aaa',
    borderRadius: '20px'
  },
  gridItem: {
    padding: '5px'
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paymentProfiles: {
    border: '1px solid',
    // marginRight: '5px',
    // padding: '5px'
  },
  bigText: {
    fontSize: '1.5em',
    color: '#333',
    textAlign: 'center'
  },
  paddedStuff: {
    padding: '5px',
    margin: '5px'
  }
}));

const handleFocus = (event) => event.target.select();

const SuppliesUsedModal = (props) => {
// console.log('SuppliesUsedModal  Props: ', props)
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false)
  const [individual, setIndividual] = React.useState(true);
  // const [invoice, setInvoice] = React.useState(null)
  const [state, setState] = React.useState({
    equipment: {},
    suppliesUsed: [],
    quantity: 0,
    overRidePrice: false
  })
  const [equipmentType, setEquipmentType] = React.useState({})
  const [item, setItem] = React.useState({})
  const equipRef = React.useRef(null)
  const handleClose = () => {
  // console.log('Closing DepositModal Modal')
    props.closeModal()
  }

const handleSave = () => {
  setLoading(true)
    props.notification({
    type: 'success',
    title: 'Added Supply!',
    message: 'Successfully Added That Item'
  })
  let newItem = item
  newItem.quantity = state.quantity
  newItem.subTotal = state.subTotal
  props.saveItem(newItem, state.quantity)
  setLoading(false)
  setState({...state,
    equipment: {},
    suppliesUsed: [],
    quantity: 0,
    overRidePrice: false
  })
  setItem({})
  // console.log('Save this Equipment!!!', equipRef)
  // equipRef.current.type = equipmentType
  // // console.log('Send this Deposit to The Server')
  //   let obj = {
  //     equipment: equipRef.current,
  //     user: props.user
  //   }
  //   axios({
  //     method: 'post',
  //     url:  `${props.url}/api/equipment/addNewEquipment`,
  //     data: obj
  //   }).then(response => {
  //     setLoading(false)
  //   // console.log('Axios response from Add addNewEquipment: ', response)
  //     if (response && response.data && response.data._id) {
  //     // console.log('We have a new equipment!!', response.data)
  //       props.notification({
  //         type: 'success',
  //         title: 'Equipment Created!',
  //         message: 'Equipment Was Created Successfully'
  //       })
  //       setState({...state,
  //         equipment: {}
  //       })
  //       // handleClose('success', response.data)
  //       props.updateParent({equipment: response.data})
  //     } else {
  //       props.notification({
  //         type: 'warning',
  //         title: 'Equipment Error',
  //         message: response.data.message
  //       })
  //       // props.notification({
  //       //   type: 'warning',
  //       //   title: 'Unknown Error',
  //       //   message: 'We Do Not Know Why This Shows Up...'
  //       // })
  //     }
  // // }).catch(response => {
  // // // console.log('Error saving equipment')
  // //   if (response && response.data && response.data.message) {
  // //   // console.log('Got an error', response.data.message)
  // //     props.notification({
  // //       type: 'warning',
  // //       title: 'Equipment Error',
  // //       message: response.data.message
  // //     })
  // //   }
  // })
}

const equipmentTypes = [
  'Vehicle',
  'Trailer',
  'Mower',
  'Trimmer',
  'Cell Phone'
]

const updateEquipmentType = (id, value) => {
  // console.log('Update equipment: ', id)
// console.log('Value: ', value)
  setEquipmentType(value)
  // setState({...state, equipment: {...state.equipment, type: value}})
}

const updateEquip = (e) => {
  // console.log('Update our Equipmenth: ', e)
  // console.log('Equip Ref', equipRef)
  if (equipRef && equipRef.current) {

  } else {
    equipRef.current = {}
  }
  let typeToUpdate = e.target.id
  let val = e.target.value
  // console.log('Equipment %s -- %s ', typeToUpdate, val)
  equipRef.current [typeToUpdate] = val
  // setState({...state, equipment: {...state.equipment, [typeToUpdate]: val}})
}

const handleTabInteraction = (e) => {
  if (e.keyCode == 9) {
  // console.log(e.target)
  }
}

const servicesList = ["Trim & Mow Lawn","Detail","Rake","Water Pots","General Clean Up","Pull Weeds","Trim Trees","Trim Plants","Check Clock","Wash Patios","Fertilize Lawn","Yard","Paperwork","Check Clocks","Remove Christmas Debris","General Clean Up At Vasoloupolis***","Check Lights","Spray Pet Area","Repair Irrigation","Check Irrigation","Dead Head Flowers","Repair Entry Gate At Motor Court***Welding Flat Rate????","Weld Back Gate Hinge","Meet With Bull Frog","Adjust Hinge Rear Gate","Cut Off Lock Pool Fence","Spray Weeds","Fertilize Roses","Check Spray Heads","Tie Vines To Wall","Spray Insecticide","Spray Simple Green","Replace Two Valves","Turn Clock On","Fertilize","Meet Tree Doctors At Powell**","Check Lights And Replace Bulbs As Needed","Check Lights And Replace Bulb As Needed","Clean Front Of Drain Pipe","Deatil","Work With Well Guys: Bloomquist Pump Service","Plant New Plants","Replace Valve","Staked Trees","Check Irrigation And Valve Boxes","Cut Up Ironwood Tree And Limbs From Storm Damage","Spray Thuricide","Work On Main Line Leak","Reset Lighting In Pool Area","Remove Broken Branch","Check Lights And Repair As Needed","Check Gfi On Tree Lights","Fix Son'S Light","Check Lights And Replace As Needed","Attach Anchors","Clean And Chlorinate Water Feature","Start Up","Transplant Cactus","Treat Rodents","Replave Valve","Work At Yard","Gopher Control","Fix Stuck Valve In Back Yard","Repair Irrigation At Bill Snyder***","Trim Roses","Staple Cables On Trees","Pull Dead Vines And Clean Area That Had Been Locked","Fertilize Cactus","Repair Lights","Stake Hop Bush","Sp y Weeds","Check Lawn And Adjust Clock As Needed","Repair Float Valve In Fountain","Pick Up Tree Branch","Repair Irrigation At Snyder**","Spread Sand","Make Plant List For Saturday","Repair Irrigation At John Pickett**","Storm Clean Up At Yard","Fertilize Plants","Repair Valve With On Site Materials","Find House Mainline Leak And Advise Caretaker","Check Sprinkler","Pick Plants At Nursery","Yard Paperwork","Cut Arm Off Totem Pole","Pick Up Granite For Tuesday","Repair Light","Pick Up Plants","Install Granite","Plant New Plants Supplied By Homeowner","Install Metal Edge","Plant New Plants (10) Supplied By Homeowner","Special Clean Up After Wind Storm","Remove Large Tree Limb Down From Wind","Transplant Prickly Pear At Road Side","Check Orchid","Check Pavers","Fertilize Flowers","Repair Irrigation Leak","Fertilize Plants`","Pick Out Sod","Install Sod","Pull 3 Oleanders At End Of Drive As Requested","Check Tree","Rake Along Old Train Tracks","Clean Up 1/2 Fallen Saguaro At Enty","Plant New Plants Provided By Homeowner","Trim Vines On Wall","Level Grass Areas With Sand","Remove Fallen Saguaro","Clean Out Water Feature","Put In New Filter Basket","Get It Running Again","Treat Texas Ebonys Along Drive","`","Fertilize Citrus","Find Leak And Talk With Nancy","Fertilize Bougainvilleas Along Office Wall","Clean Weeds From Planters Along Roses","Move Cactus Around In Desert As Requested","Restart River Feature","Clean Out Water Filter Line","Check Tree Trimming","Lock Back Gate","","Ferilize Lawn","Ferilize","Change Out Entry Transformer","Check Trees","Trim Tree Branch From Elm","Check Clock And Adjust Times As Needed","Plant New Plant At Entry","Spray Spray Pet Area","Trim Citrus","Check Trimmed Rosemary","Purchase Plants For Friday Planting","Check Grass And Adjust Clock As Needed","Pull Bougainvilleas Off Wall","Power Wash Patios","Plant New Plants In Front Pots","Use Wooden Planks To Supprt Saguaro","Shut Down Water Feature River For Summer","Check Painters","Check Bougainvilleas Off The Wall","Pull Cables From Trimmed Trees","Pick Plants And Flowers For Planting","Layout For Crew","Plant Flowers","Shut Down Clock For Nutgrass Treatment Monday","Check Artificial Grass","Check Lights And Replace Existing With New Led","Wire Bougainvilleas To Wall After Painting","Troubleshoot Clock And Wiring","Valves","Repaair Leaking Pot","Check New Plantings","Re-Do Pot With Mircro Tubing","Put Pot Together After ReSealing","Wash Patios And Walls","Blow Backyard As Requested","Plant Flowers From Homeowner","Detail Backyard By Pool","Blow All Areas And Rake Drive","Wire Bougainvillea Back On Wall After Paint","Take Down Balance Of Elm Tree Cables","Remove 2 Sago Palms In Back Yard","Check Bougainvilleas","Install New Poly Line In Front Planter","No Power To Clocks","Fix Leak At Pool House Pots","Put Volleyball Net Back Up","Fertilize Bougainvilleas South Side Of Office","Pull Winter Flowers","Take Out Plants As Requested","Change Palm Crew","Layout Plants From Owner For Install Crew","Set Up Palm Crew","Shut Water Off To Grass To Prep For Artificial Turf","Check Sour Orange","Fill In Planter At Guesthouse After Plumber Repair Work","Remove Flowers","Check Palm Tree Trimming","Lay Out And Plants Flowers","Get Flowers","Layout","Prep Flower Beds","And Plant Flowers","Run Micro Tubing In Planters","General Clean Up With Install Crew","Put Cushions Away For Summer","Remove Plants In Back","Run Irrigation To Flowers","x","Repair Irrigation Leak Under Drive In Sleeve","Walk Property With House Manager","Troubleshoot Hammer Noise In Pipes","Trim And Mow Lawn","Check Broken Window","Check Gate","Check Flowerbed For Leak","None Found","Adjust Clock","Turn Off Clock For Nutgrass Spraying","Trim & Moaw Lawn","Power Rake Lawn","Staked Tree","Take Out Cactus","Remove Agave Out Of Driveway {Storm Clean Up}","Find Mainline House Leak","Tie Bougainvilleas Back On Garage","Cut Up Broken Tree Limbs","Stake Ocotillo","Set Transformer","Reset Wire Around Agave","Remove Debris","Check Leak In Fert Tank","Remove (2) Large Ocotillio","Put Out Putting Green In Backyard","Find Leak At Meter Call For Plumber Repair","Clean All Trash Off Of Roof","Blow Off Roof AS and JN Install Bill Install?","Check Broken Tree Limb","Check Grass","Repair Leaks","Repair Irrigation Under Artifical Turf","Check Clock Replace And Reprogram As Needed","#VALUE!","Leak At Drive","Shade Plants","Blow Pots And Driveway","Cover Plants"]

const handleUpdateServices = (e, service) => {
  // console.log(e.target)
// console.log(service)
  let thisService = service[service.length - 1]
// console.log('This service: ', thisService)
  // setsuppliesUsed(service)
  setItem(service)
  setState({...state, suppliesUsed: service })
}

const calculateTotal = (unitCost, qty) => {
  let total = 0
  total = parseFloat(unitCost * qty)
  return total
}
const handleUpdateUnitCost = (e) => {
  let total = calculateTotal(e.target.value, state.quantity)
  let newItem = item
  newItem.unitCost = e.target.value
// console.log(newItem)
  setItem(newItem)
  setState({...state, unitCost: e.target.value, subTotal: total})

}

const handleUpdateQty = (e) => {
  let total = calculateTotal(item.unitCost, e.target.value)
// console.log('Total: ', total)
  setState({...state, quantity: e.target.value, subTotal: total})

}
return (
  <div className={classes.root}>
    <Dialog open={props.open} fullWidth={true} onClose={handleClose} maxWidth='md' aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Supplies Used {(props.client && props.client.displayName) ? `For ${props.client.displayName}` : ''}</DialogTitle>
        <DialogContent >
          <DialogContentText>
            Which Supplies Were Used?
          </DialogContentText>
          <Grid container spacing={3}>
            <Grid item lg={12} xs={12}>
            <Autocomplete
            // freeSolo
            // multiple
            id="suppliesUsed"
            fullWidth
            options={props.supplies || []}
            onChange={handleUpdateServices}
            // disableCloseOnSelect
            getOptionLabel={(option) => {
              // Value selected with enter, right from the input
              // if (option && option.name) return option.name
              if (typeof option === 'string') {
                return option;
              }
              // Add "xxx" option created dynamically
              if (option.inputValue) {
                return 'Save ' + option.inputValue + ' as a New Item';
              }
              // Regular option
              return `${option.code} - ${option.name}`
            }}
            renderOption={(option, { selected }) => {
              // // console.log('OPTIONS: ', option)
              // if (option.inputValue) {
              //   return (
              //     <React.Fragment>
              //   <Checkbox
              //     icon={icon}
              //     checkedIcon={checkedIcon}
              //     style={{ marginRight: 8 }}
              //     checked={selected}
              //   />
              //   {`Add ${option.inputValue} as a New Supplier`}
              // </React.Fragment>
              //   )
              // } else {
                return `${option.code} - ${option.name} - $${option.unitCost}`
              //   (
              // <React.Fragment>
              //   <Checkbox
              //     icon={icon}
              //     checkedIcon={checkedIcon}
              //     style={{ marginRight: 8 }}
              //     checked={selected}
              //   />
              //   {`${option.code} - ${option.name}`}
              // </React.Fragment>
              //   )
            }}
            
            filterOptions={filterOptions}
            // (options, params) => {
            // // console.log('Filtered Options', options)
            //   // // console.log('Params', params)
            //   // // console.log('Input value: ', params.inputValue)
            //   const filtered = filterOptions(options, params);
      
            //   // Suggest the creation of a new value
            //   // if (params.inputValue !== '') {
            //   //   filtered.push({
            //   //     inputValue: params.inputValue,
            //   //     title: `Add "${params.inputValue}"`,
            //   //     name: 'Add New Supplier'
            //   //   });
            //   // }
      
            //   return filtered;
            // }}

            renderInput={(params) => (
              <TextField {...params} onKeyDown={handleTabInteraction} style={{marginBottom: '20px'}} variant="outlined" label="Supplies Used" placeholder="Which Supplies Were Used?" />
            )}
          />
            </Grid>
            <Grid item lg={4} xs={12}>
              <TextField
                  label="Code"
                  fullWidth
                  value={item.code || ''}
                  id={`code`}
                  variant="outlined"
                  // label="Supplies Used"
                  // placeholder="Item Code"
                  disabled
                  
                  // onChange={e=>props.changeItem(item, 'desc', e.target.value, index)}
                />
            </Grid>
            <Grid item lg={8} xs={12}>
              <TextField
                  label="Name"
                  fullWidth
                  value={item.name || ''}
                  id={`name`}
                  variant="outlined"
                  disabled
                  // label="Supplies Used"
                  // placeholder="Item Name"
                  // onChange={e=>props.changeItem(item, 'desc', e.target.value, index)}
                />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                  label="Quantity"
                  fullWidth
                  value={state.quantity}
                  id={`qty`}
                  variant="outlined"
                  // label="Supplies Used"
                  onFocus={handleFocus}
                  placeholder="How Many?"
                  onChange={handleUpdateQty}
                  // onChange={e=>props.changeItem(item, 'desc', e.target.value, index)}
                />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                  label="Cost Per"
                  fullWidth
                  onFocus={handleFocus}
                  variant="outlined"
                  placeholder="Cost Per Unit"
                  value={item.unitCost || 0}
                  id={`costPer`}
                  onChange={handleUpdateUnitCost}
                  // onChange={e=>props.changeItem(item, 'desc', e.target.value, index)}
                />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                  label="Item Total"
                  fullWidth
                  variant="outlined"
                  // placeholder="Cost Per Unit"
                  value={state.subTotal || 0}
                  id={`subTotal`}
                  // onChange={e=>props.changeItem(item, 'desc', e.target.value, index)}
                />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setState({...state, editJobName: false})} color="primary">
            Cancel
          </Button> */}
          <Button color="primary" disabled={loading || !state.quantity || !item || !item.unitCost} onClick={handleSave}>
            {
              loading ? <CircularProgress /> : 'Save'
            }
          </Button>
        </DialogActions>
      </Dialog>
  </div>
  )
  }


  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification
    }
  }
  
  export default connect(mapStateToProps)(SuppliesUsedModal)